import { styled } from '@mui/material';
import { ButtonWithLoader } from 'shared/components';
import { useIsMobile } from 'shared/hooks';

import DialogAlertSection from './DialogAlertSection';

interface DialogSubmitPanelProps {
    onSubmit: () => void;
    isSubmitting: boolean;
    label: string;
    error?: string;
}

export default function DialogSubmitPanel({ onSubmit, isSubmitting, label, error }: DialogSubmitPanelProps) {
    const isMobile = useIsMobile();

    return (
        <>
            <DialogAlertSection error={ error } />

            <ButtonsContainer>
                <ButtonWithLoader variant="contained"
                    onClick={ onSubmit }
                    loading={ isSubmitting }
                    fullWidth={ isMobile }
                >
                    { label }
                </ButtonWithLoader>
            </ButtonsContainer>
        </>
    );
}

const ButtonsContainer = styled('div')(({ theme }) => ({
    width: '100%',
    paddingTop: theme.spacing(6),
    display: 'flex',
    justifyContent: 'flex-end',

    [theme.breakpoints.down('sm')]: {
        button: {
            flex: 1
        }
    }
}));
